/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Mcp_Access_ShowInputs */



/**
* | output |
* | --- |
* | "Show setup" |
*
* @param {My_Integrations_Mcp_Access_ShowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_mcp_access_show = /** @type {((inputs?: My_Integrations_Mcp_Access_ShowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Mcp_Access_ShowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einrichtung anzeigen")
	return /** @type {LocalizedString} */ ("Show setup")
});